import { RtError } from '@core/utils-legacy';

export class PdfViewerConfigNotProvidedError extends RtError {
  constructor() {
    super('PdfViewerConfigNotProvidedError', 'Config for PdfViewer not provided');
  }
}
